
  import { Component, Vue } from 'vue-property-decorator';
  import LoginHome from './Home.vue';
  import LoginOneStep from './OneStep.vue';
  import LoginPassword from './Password.vue';
  import LoginPartner from './Partner.vue';
  import AgeVerification from './AgeVerification.vue'
  import AcceptTerms from './AcceptTerms.vue'
  import AccessRestricted from './AccessRestricted.vue'
  import { ILoginModel, IIdentifyUserResultModel } from '../../models/login.model';

  @Component({
    components: {
      LoginHome,
      LoginOneStep,
      LoginPassword,
      LoginPartner,
      AgeVerification,
      AcceptTerms,
      AccessRestricted,
    }
  })
  export default class Login extends Vue {
    data() {
      return {
        studio: '',
        currentView: '',
        user: {} as ILoginModel,
        isLowThresholdAgeGateBirthdaySoon: false,
        dateofBirthCreatedAt: undefined,
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
      this.$data.currentView = this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'TWO-POINT-STUDIOS' || this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'SANDBOX' ? 'LoginOneStep' : 'LoginHome';
    }

    public updateCurrentView(view: string, userResult: IIdentifyUserResultModel): void {
      this.$data.currentView = view;
      this.$data.user = {
        AuthPartner: userResult.AuthPartner,
        Id_User: userResult.Id_User,
        Username: userResult.Username,
        Title: this.formatTitleName(userResult.TitleName),
        Email: userResult.Email,
        Avatar: userResult.AvatarUrl
      } as ILoginModel;
    };

    public updateUser() {
    };

    public updateIsLowThresholdAgeGateBirthdaySoon(value: boolean): void {
      this.$data.isLowThresholdAgeGateBirthdaySoon = value;
    }

    public updateDateOfBirthCreatedAt(value: Date): void {
      this.$data.dateofBirthCreatedAt = value;
    }

    private formatTitleName(title: string): string {
      if (title != null && title.length > 0) {
        var titleName = title.split(';');
        title = titleName.join(' ');
      }

      return title;
    }
  }
